export const TEXT_ALIGN_TYPES = [
  'left',
  'center',
  'right',
  'justify'
]
